export const environment = {
  production: false,
  baseHref: '/',
  vtkUrl: 'https://vtk.dev.fldinc.com/',
  serviceWorker: {
    enabled: false,
    updateCheckInterval: 30000
  },
  msalConfig: {
    auth: {
      clientId: 'f82532a2-967a-425d-88ed-6ae1f77ef981', // Replace with your Azure AD app registration client ID
      authority: 'https://login.microsoftonline.com/fleetlease.onmicrosoft.com/v2.0', // Replace with your tenant ID
      redirectUri: 'https://localhost:4200',
      postLogoutRedirectUri: 'https://localhost:4200'
    },
    cache: {
      cacheLocation: 'localStorage' as const,
      storeAuthStateInCookie: false
    }
  },
  apiConfig: {
    scopes: ['f82532a2-967a-425d-88ed-6ae1f77ef981/.default'], // Use client ID directly as audience
    uri: 'https://localhost:7282/dbhub/'
  },
  graphScopes: ['https://graph.microsoft.com/Mail.ReadWrite']
};